import { render, staticRenderFns } from "./NotificationLogTab.vue?vue&type=template&id=21ba04ba&scoped=true"
import script from "./NotificationLogTab.vue?vue&type=script&lang=js"
export * from "./NotificationLogTab.vue?vue&type=script&lang=js"
import style0 from "./NotificationLogTab.vue?vue&type=style&index=0&id=21ba04ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba04ba",
  null
  
)

export default component.exports